import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 56px 160px;
  ${({ theme }) => theme.media.tablet} {
    padding: 56px 32px;
  }
  ${({ theme }) => theme.media.phone} {
    padding: 30px 16px 56px;
  }
`

export const Content = styled.div`
  height: 100%;
  width: 100%;
  max-width: 1440px;
  padding: 0 0 30px;

  .gsc-webResult.gsc-result,
  .gsc-control-cse {
    background-color: ${({ theme }) => theme.colors.lightGrey};
    border-color: ${({ theme }) => theme.colors.lightGrey};
    padding: 10px 0;
  }
  .gsc-adBlock {
    display: none;
  }
  .gsc-results .gsc-cursor-box .gsc-cursor-current-page {
    background-color: ${({ theme }) => theme.colors.lightGrey};
  }
  .gsc-cursor-page {
    background-color: ${({ theme }) => theme.colors.lightGrey} !important;
    margin-right: 20px !important;
  }
`

export const Title = styled.div`
  font-size: 28px;
`
